import { render, staticRenderFns } from "./PurchaseHistory.vue?vue&type=template&id=0583eb3f&scoped=true&"
import script from "./PurchaseHistory.vue?vue&type=script&lang=js&"
export * from "./PurchaseHistory.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseHistory.vue?vue&type=style&index=0&id=0583eb3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0583eb3f",
  null
  
)

export default component.exports